import { hasLayers, makePolicySummaryRows } from "./policySummarySupport";
import {
  Box,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import CopyButton from "components/common/CopyButton";
import StatusBadge from "components/common/StatusBadgeV2";
import * as labels from "config.labels";
import * as staticDataHooks from "store/hooks/staticDataHooks";

const NO_LAYERS = "No layers have been added to this submission yet";

const Caption = ({ children }) => (
  <Typography variant={"caption"} color={"text.secondary"} component={"div"}>
    {children}
  </Typography>
);

const PolicySummary = ({ layers }) => {
  const translateLabel = staticDataHooks.useTranslator("uiLabels");
  const label = translateLabel(labels.POLICY_SUMMARY, {
    default: "Policy Summary",
  });

  const showRows = hasLayers(layers);
  const rows = showRows ? makePolicySummaryRows(layers) : [];

  return (
    <Grid item xs={12}>
      <Caption>{label}</Caption>
      <Box
        sx={{
          border: 1,
          borderColor: "divider",
          borderRadius: 1,
          mt: 0.5,
          overflowX: "auto",
        }}
      >
        <Table size={"small"}>
          <TableHead>
            <TableRow>
              <TableCell>{"Layer"}</TableCell>
              <TableCell>{"Status"}</TableCell>
              <TableCell>{"Policy Number"}</TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map(({ key, layerNumber, name, status, reference }) => (
              <TableRow key={`policy-summary-${key}`}>
                <TableCell sx={{ whiteSpace: "nowrap" }}>
                  {name ?? `Layer ${layerNumber}`}
                </TableCell>
                <TableCell>
                  {status ? <StatusBadge status={status} /> : "—"}
                </TableCell>
                <TableCell>{reference ?? "—"}</TableCell>
                <TableCell>
                  {reference && (
                    <CopyButton
                      content={reference}
                      tooltip={"Copy policy number"}
                      scale={"small"}
                    />
                  )}
                </TableCell>
              </TableRow>
            ))}
            {!showRows && (
              <TableRow>
                <TableCell colSpan={4} align={"center"} sx={{ padding: 3 }}>
                  {NO_LAYERS}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </Box>
    </Grid>
  );
};

export default PolicySummary;
